import './mask-field-text.scss'

import { PropType } from "vue"
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import _ from 'lodash';

import { EntityField, EntityFieldStatus, TranslatedString, createTranslatedString, editTranslatedString, getTranslatedString } from '@skinsoft/types';

import { ReactiveVue } from '@skinsoft/reactive-vue';

@Component({
    components: {

    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
        },
        fieldValue: {},
        editing: {
            type: Boolean,
        },
        getStatus: {},
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-text.html')
})
export class MaskFieldText extends ReactiveVue {
    private entityField: EntityField
    private fieldValue: any
    private editing: Boolean
    private dataCy: String
    private getStatus: (entityField: EntityField) => EntityFieldStatus

    private get value(): String {
        if(this.entityField.type?.type === "TranslatedString") {
            return getTranslatedString(this.fieldValue, this.getAppLocale())
        }
        return _.get(this.fieldValue, 'value') ?? this.fieldValue ?? ""
    }

    private set value(input: String) {
        let returnValue: TranslatedString | String = input
        
        if(this.entityField.type?.type === "TranslatedString") {
            if (this.fieldValue) {
                returnValue = _.cloneDeep(this.fieldValue)
                editTranslatedString(returnValue as TranslatedString, input as string, this.getAppLocale())
            } else {
                returnValue = createTranslatedString(this.getAppLocale(), input as string)
            }
        }

        this.$emit("value-change", {
            abstractEntity: this.entityField.abstractEntity,
            fieldPath: this.entityField.path,
            value: returnValue,
        })
    }

    private isReadonly(entityField: EntityField) {
        return entityField.isReadOnly || this.getStatus(entityField).disabled
    }

    private infoMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).disabledMessage
    }

    private errorMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).errorMessage
    }

    private hasError(entityField: EntityField) {
        return this.getStatus(entityField).error
    }

    @Watch("fieldValue")
    private onFieldValueChanged() {
        // sometimes the b-modal doesn't update if value is undefined 
        // and it still displays old value
        this.$forceUpdate()
    }
}